import type { GameMeta } from "@kit/meta";

export const meta: GameMeta = {
  id: "harf-yilani",
  name: "Harf Yılanı",
  tagline: "Harfleri topla, kelimeyi tamamla; uzun kelime yılanı büyütür.",
  inspiredBy: "Snake × word puzzle",
  secondLayer: "Her koşu yeni bir harf akışı; paylaşılan link (koşunun diliyle) arkadaşına aynı harfleri açar. Kelime bonusu uzunluğun karesiyle artar.",
  accent: "#ff924c",
  status: "lab",
};
